<mat-table [dataSource]="angularMatData" matSort matSortDisableClear matSortActive="ScreenedDate" matSortDirection="desc" style="width: 100%" aria-label="Screening Details Table">
  <ng-container matColumnDef="ScreenedDate">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Screened</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="ScreenedDate" dataType="date"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.ScreenedDate|date:'MM/dd/yy'}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="SeriesName">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Series</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="SeriesName" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.SeriesName}}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="SportsScreening">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Sports Screening</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="SportsScreening" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.SportsScreening == true ? 'Yes' : 'No'}}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="ScheduledDate">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{screeningId == 8 ? 'Requested' : 'Scheduled' | translate}}
      <filter class="mat-filter" [data]="angularMatData" columnName="ScheduledDate" dataType="date"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.ScheduledDate|date:'MM/dd/yy'}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="ResultCode">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{screeningId == 8 ? 'Areas' : 'Result' | translate}}
      <filter class="mat-filter" [data]="angularMatData" columnName="ResultCode" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.ResultCode}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="Referral">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Referral</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="Referral" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.Referral}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="ReferralStatus">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Referral Status</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="ReferralStatus" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.ReferralStatus}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="Comments">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Comments</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="Comments" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.Comments}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="Height">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Height (inches)</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="Height" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.Height | number:'.0-2'}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="Weight">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Weight (pounds)</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="Weight" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.Weight| number:'.0-2'}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="BMI">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>BMI</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="BMI" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.BMI| number:'.0-2'}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="BMIPercentile">
    <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>BMI Percentile</span>
      <filter class="mat-filter" [data]="angularMatData" columnName="BMIPercentile" dataType="string"></filter>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.BMIPercentile| number:'.0-1'}}</mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayColumns;"></mat-row>
</mat-table>
